export default function ArrowUpRightIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 4.2222V13.6108C16.5 13.8023 16.4239 13.986 16.2885 14.1215C16.153 14.2569 15.9693 14.333 15.7778 14.333C15.5863 14.333 15.4026 14.2569 15.2671 14.1215C15.1317 13.986 15.0556 13.8023 15.0556 13.6108V5.96541L4.73356 16.2884C4.59804 16.4239 4.41425 16.5 4.2226 16.5C4.03096 16.5 3.84716 16.4239 3.71165 16.2884C3.57613 16.1528 3.5 15.969 3.5 15.7774C3.5 15.5858 3.57613 15.402 3.71165 15.2664L14.0346 4.9444H6.3892C6.19766 4.9444 6.01397 4.86831 5.87853 4.73287C5.74309 4.59743 5.667 4.41374 5.667 4.2222C5.667 4.03066 5.74309 3.84697 5.87853 3.71153C6.01397 3.57609 6.19766 3.5 6.3892 3.5H15.7778C15.9693 3.5 16.153 3.57609 16.2885 3.71153C16.4239 3.84697 16.5 4.03066 16.5 4.2222Z"
        fill="currentColor"
      />
    </svg>
  );
}
